<template lang="pug">
    li
        .dropdown(@mouseover="openModal", @mouseleave="closeModal")
            router-link.dropdown__toggle(:to="nav.link") {{ nav.title }}
            transition(name="fade")
                .dropdown__content.dropdown-products(v-bind:class="{ 'open': active }", v-if="nav.options.length")
                    ul.list-style-none.is-dropdown
                        li(v-for="subopt in nav.options")
                            router-link.is-dropped(:to="subopt.link") {{ subopt.title }}
</template>

<script>
export default {
    props: ['nav'],
    data: function(){
        return {
            active: false
        }
    },
    methods: {
        openModal: function(){
            this.$data.active = true
        },
        closeModal: function(){
            this.$data.active = false
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PmNavOpt.vue